var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stats'),_c('div',{staticClass:"main"},[_c('LeftCol'),_c('router-view'),_c('calc',{ref:"num",on:{"send-bets":function($event){return _vm.send_bets()}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }